import { observer } from 'mobx-react-lite'
import { Box, CardsFilter } from 'shared/ui'
import { useReviewAnalyticsContext } from 'pages/reviews/context'

export const ReviewStatistics = observer(() => {
  const { statBlocks, activeFilter, setActiveFilter } = useReviewAnalyticsContext()

  if (!statBlocks.length) return null

  return (
    <Box padding={'0 20px'}>
      <CardsFilter
        items={statBlocks}
        activeKey={activeFilter}
        onActiveFilter={(item) => setActiveFilter(item.key)}
      />
    </Box>
  )
})
